import React from 'react';
import SentryContext from './SentryContext';

export default function SentryProvider(props) {
  return <SentryContext.Provider value={props.value}>{props.children}</SentryContext.Provider>;
}
